import { render, staticRenderFns } from "./TintForm.vue?vue&type=template&id=a06797c4&"
import script from "./TintForm.vue?vue&type=script&lang=js&"
export * from "./TintForm.vue?vue&type=script&lang=js&"
import style0 from "./TintForm.vue?vue&type=style&index=0&id=a06797c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports